import { render } from "./ReportDetailsHeader.vue?vue&type=template&id=6da34cb4&scoped=true"
import script from "./ReportDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ReportDetailsHeader.vue?vue&type=script&lang=js"

import "./ReportDetailsHeader.vue?vue&type=style&index=0&id=6da34cb4&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da34cb4"]])

export default __exports__